export default __webpack_public_path__ + "static/media/Emblem.5a5774ed.svg";